import request from "../request";

/**
 * Проверяет подписку на матч
 */
export const hasSubscription = ({ eventId }) => {
  return request({
    url: "mail-subscription/has-subscription",
    type: "GET",
    data: { event_id: eventId }
  });
};

/**
 * Подписывается на матч
 */
export const add = ({ eventId }) => {
  return request({
    url: "mail-subscription/add",
    type: "GET",
    data: { event_id: eventId }
  });
};

/**
 * Отписывается от матча
 */
export const remove = ({ eventId }) => {
  return request({
    url: "mail-subscription/remove",
    type: "GET",
    data: { event_id: eventId }
  });
};